import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { formatFromLocalDate } from 'app/shared/util/date-utils';

const CompetitionTable: React.FC = () => {
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));

  return LazyTable({
    initialSortField: 'id',
    initialSortDirection: 'desc',
    createUrl: '/create-competition',
    labelForCreateEntity: isAdmin ? 'Vytvoriť súťaž' : null,
    serverUrl: '/api/competitions',
    editActionAllowed: isAdmin,
    infoActionAllowed: !isAdmin,
    globalFilterFields: ['name', 'insuranceCompany.name', 'productType.name'],
    searchAllowed: false,
    columns: [
      { field: 'id', header: 'ID', sortable: true },
      { field: 'title', header: 'Názov súťaže', sortable: true },
      { field: 'validFrom', header: 'Od', sortable: true, formatter: formatFromLocalDate },
      { field: 'validTo', header: 'Do', sortable: true, formatter: formatFromLocalDate },
    ],
  });
};

export default CompetitionTable;
